
import { combineReducers } from 'redux';

import search from './search';
import definition from './definition';
import ui from './ui';

export function getDefinition(state) {
    return state.definition;
}

export function getSearch(state) {
    return state.search;
}

export function getUi(state) {
    return state.ui;
}

export default combineReducers({
    definition,
    search,
    ui
});
